/* eslint-disable @angular-eslint/no-conflicting-lifecycle */
/**
 * Normally, you shouldn't use DoCheck and OnChanges together.
 * We are using it here safely however, and it enables this grid to
 * work properly. Some future dev should feel free to figure out
 * how to avoid this however, and remove the disabling of this rule
 */
import { DataSource, _RecycleViewRepeaterStrategy, _VIEW_REPEATER_STRATEGY } from '@angular/cdk/collections';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { ChangeDetectorRef, Directive, OnChanges, OnInit, DoCheck, Input, OnDestroy, runInInjectionContext, Injector } from '@angular/core';
import { GridVirtualScrollViewportComponent } from './components/grid-virtual-scroll-viewport/grid-virtual-scroll-viewport.component';
import { CdkVirtualForOfOverrrideDirective } from './override/cdk-virtual-for-of-override.directive';
/**
 * Add the template content to the DOM unless the condition is true.
 */
@Directive({
	selector: '[gridVirtualFor]', providers: [_RecycleViewRepeaterStrategy, { provide: _VIEW_REPEATER_STRATEGY, useClass: _RecycleViewRepeaterStrategy }],
	standalone: false
})
export class GridVirtualForOfDirective implements OnDestroy, OnChanges, OnInit, DoCheck {
	@Input('gridVirtualForItemMinWidth') public itemMinWidth: number;
	@Input('gridVirtualForItemMaxWidth') public itemMaxWidth: number;
	@Input('gridVirtualForMinGap') public minGap: number;
	@Input('gridVirtualForOf') public data: DataSource<any>; // eslint-disable-line @angular-eslint/no-input-rename

	public virtualGrid?: CdkVirtualForOfOverrrideDirective;

	constructor (
		private viewport: GridVirtualScrollViewportComponent,
		private cdr: ChangeDetectorRef,
		private injector: Injector
	) {
	}

	public ngOnInit (): void {

		// wait for viewport to render
		this.viewport.cdkViewportLoaded$.subscribe((cdkViewport: CdkVirtualScrollViewport) => {
			this.virtualGrid = runInInjectionContext(this.injector, () => {
				return new CdkVirtualForOfOverrrideDirective(
					cdkViewport,
					this.cdr
				);
			});
			this.virtualGrid.itemMinWidth = this.itemMinWidth;
			this.virtualGrid.itemMaxWidth = this.itemMaxWidth;
			this.virtualGrid.minGap = this.minGap;
			this.virtualGrid.cdkGridVirtualForOverrideOf = this.data;
		});
	}

	public ngOnChanges (): void {
		if (this.virtualGrid == null) {
			return;
		}

		this.virtualGrid.itemMinWidth = this.itemMinWidth;
		this.virtualGrid.itemMaxWidth = this.itemMaxWidth;
		this.virtualGrid.minGap = this.minGap;
		this.virtualGrid.cdkGridVirtualForOverrideOf = this.data;
	}

	public ngDoCheck (): void {
		this.virtualGrid?.ngDoCheck();
	}

	public ngOnDestroy (): void {
		this.virtualGrid?.ngOnDestroy();
	}
}
